if (!customElements.get('wlsn-early-access-form')) {
    class WLSNEarlyAccessForm extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                open: 'is-open',
                bodyLock: 'body-lock',

                trigger: 'js-wlsn-early-access-form-trigger',
                close: 'js-wlsn-early-access-form-close',

                form: 'js-wlsn-early-access-form-form',
                input: 'js-wlsn-early-access-form-input',
                submit: 'js-wlsn-early-access-form-submit',
                message: 'js-wlsn-early-access-form-feedback-message',
            };

            this.handleDocumentClick =
                this.handleDocumentClick.bind(this);

            this.handleSubmit =
                this.handleSubmit.bind(this);
        }

        connectedCallback() {
            this.successUrl = this.dataset.successUrl;
            this.klaviyoFormId = this.dataset.klaviyoFormId;
            this.elements = {
                inner: this.querySelector(
                    '.wlsn-early-access-form__inner'
                ),

                form: this.querySelector(
                    `.${this.classes.form}`
                ),

                input: this.querySelector(
                    `.${this.classes.input}`
                ),

                submit: this.querySelector(
                    `.${this.classes.submit}`
                ),

                message: this.querySelector(
                    `.${this.classes.message}`
                ),
            };

            document.addEventListener(
                'click',
                this.handleDocumentClick
            );

            this.elements.form?.addEventListener(
                'submit',
                this.handleSubmit
            );
        }

        disconnectedCallback() {
            document.removeEventListener(
                'click',
                this.handleDocumentClick
            );

            this.elements.form?.removeEventListener(
                'submit',
                this.handleSubmit
            );
        }

        open() {
            this.classList.add(this.classes.open);

            document.body.classList.add(
                this.classes.bodyLock
            );
        }

        close() {
            this.classList.remove(this.classes.open);

            document.body.classList.remove(
                this.classes.bodyLock
            );
        }

        async handleSubmit(e) {
            e.preventDefault();

            const email =
                this.elements.input.value.trim();

            if (!this.isEmail(email)) {
                this.showMessage(
                    'Please enter a valid email address.',
                    'error'
                );

                return;
            }

            this.elements.submit.disabled = true;

            try {
                const response = await fetch(
                    'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
                    {
                        method: 'POST',

                        headers: {
                            accept:
                                'application/json, text/plain, */*',

                            'content-type':
                                'application/x-www-form-urlencoded;charset=UTF-8',
                        },

                        body: new URLSearchParams({
                            g: this.klaviyoFormId,
                            email,
                        }),
                    }
                );

                const data = await response.json();

                if (data.success) {
                    this.showMessage(
                        'You have subscribed successfully.',
                        'success'
                    );

                    this.elements.form.reset();

                    if (this.successUrl) {
                        window.location.href = this.successUrl;
                    
                        return;
                    }
                    
                    setTimeout(() => {
                        this.close();
                    }, 1500);

                    return;
                }

                this.showMessage(
                    'Something went wrong.',
                    'error'
                );
            } catch (error) {
                console.error(error);

                this.showMessage(
                    'Something went wrong.',
                    'error'
                );
            } finally {
                this.elements.submit.disabled = false;
            }
        }

        handleDocumentClick(e) {
            const trigger = e.target.closest(
                `.${this.classes.trigger}`
            );

            const closeBtn = e.target.closest(
                `.${this.classes.close}`
            );

            if (trigger) {
                e.preventDefault();

                this.open();

                return;
            }

            if (closeBtn) {
                this.close();

                return;
            }

            if (
                this.classList.contains(
                    this.classes.open
                ) &&
                !this.elements.inner.contains(e.target)
            ) {
                this.close();
            }
        }

        showMessage(message, type) {
            this.elements.message.textContent =
                message;

            this.elements.message.classList.remove(
                'success',
                'error'
            );

            this.elements.message.classList.add(
                type
            );
        }

        isEmail(email) {
            const emailRegex =
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            return emailRegex.test(email);
        }
    }

    customElements.define(
        'wlsn-early-access-form',
        WLSNEarlyAccessForm
    );
}